import {
    BasicResponsiveImage,
    BoundedContent,
    Button,
    Column,
    GridContainer,
    H2,
    Link,
    Popover,
    PopoverContent,
    PopoverLauncher,
    Row,
    Typography,
} from '@vp/swan';
import { CLOUDINARY_BASE_URL } from '@99designs/design-services-common';

export function HowItWorks() {
    const imageURL = `${CLOUDINARY_BASE_URL}/c_scale,dpr_auto,f_auto,q_auto:good,w_auto/expert_services/SDP/TieringExperiment/HowItWorks/how-it-works-EN`;
    const altText =
        "A design process for a pizza restaurant. A female business owner is shown with a 'Design Brief' that says, 'I need an eye-catching design for my pizza restaurant!' Below, a male designer presents a draft for 'Frankie's Pizza' with a logo.";
    return (
        <BoundedContent>
            <GridContainer>
                <Row>
                    <Column span={6} verticallyCenterContent={true}>
                        <H2 fontSkin="title-section" mb={7}>
                            The design process explained
                        </H2>
                        <Typography fontSkin="title-subsection" fontSize="large">
                            1. Complete your brief
                        </Typography>
                        <Typography mt={4}>
                            Fill out a quick, online form (your brief) with details about your
                            design idea - think text, colors and images. Once you're ready, hit
                            submit.
                        </Typography>

                        <Typography fontSkin="title-subsection" fontSize="large" mt={6}>
                            2. Designer matching
                        </Typography>
                        <Typography mt={4}>
                            Your Simple Design project will be assigned to the first available
                            designer.
                        </Typography>
                        <Typography mt={5}>
                            For an Exclusive Design project, you can view designers' pitches,
                            reviews and portfolios to pick the right one for you.
                        </Typography>
                        <Typography fontSkin="title-subsection" fontSize="large" mt={6}>
                            3. Receive and review your design
                        </Typography>
                        <Typography mt={4}>
                            Now it's time to review your design and make any necessary revisions
                            with your designer as you{' '}
                            <Popover display="inline-block">
                                <PopoverLauncher>
                                    <Link
                                        render={(p, ref) => (
                                            <Button
                                                ref={ref}
                                                skin="link"
                                                className={p.className}
                                                {...p}
                                            />
                                        )}
                                    >
                                        share your feedback online
                                    </Link>
                                </PopoverLauncher>
                                <PopoverContent>
                                    We’ll send you an email when your design is ready to review.
                                    From there, you can review your design and provide written
                                    feedback based on your design service’s revision rounds and
                                    timeframe.
                                </PopoverContent>
                            </Popover>
                            .
                        </Typography>
                        <Typography fontSkin="title-subsection" fontSize="large" mt={6}>
                            4. Approve your design
                        </Typography>
                        <Typography mt={4} mb={6}>
                            Once you're happy, your finished design will be loaded into your
                            VistaPrint account, ready for you to print at any time.
                        </Typography>
                    </Column>
                    <Column
                        span={6}
                        spanLg={5}
                        offsetLg={1}
                        spanXl={5}
                        offsetXl={1}
                        verticallyCenterContent={true}
                    >
                        <BasicResponsiveImage aspectRatio={1} src={imageURL} alt={altText} />
                    </Column>
                </Row>
            </GridContainer>
        </BoundedContent>
    );
}
